import React from 'react';
import useStyleVars from '@hooks/useStyleVars';
import classNames from 'classnames';
import * as styles from './DashedLine.module.scss';

export default React.forwardRef(function DashedLine(
  { className, strokeWidth, color, direction = 'vertical', ...restProps },
  ref
) {
  const { timelineTrackColor, timelineStrokeWidth } = useStyleVars();

  color = color ?? timelineTrackColor;
  strokeWidth = strokeWidth ?? timelineStrokeWidth;

  const h = Math.ceil(strokeWidth / 2);
  const svgProps = {};
  const lineProps = {};

  if (direction === 'vertical') {
    svgProps.viewBox = `0 0 ${strokeWidth} 100`;
    svgProps.width = Math.ceil(strokeWidth);
    svgProps.height = 100;

    lineProps.x1 = h;
    lineProps.x2 = h;
    lineProps.y1 = 0;
    lineProps.y2 = 100;
  } else {
    svgProps.viewBox = `0 0 100 ${strokeWidth}`;
    svgProps.width = 100;
    svgProps.height = h;
    svgProps.style = { height: Math.ceil(strokeWidth) };

    lineProps.x1 = 0;
    lineProps.x2 = 100;
    lineProps.y1 = h;
    lineProps.y2 = h;
  }

  return (
    <svg
      ref={ref}
      className={classNames('line', styles.line, className, {
        [styles.horizontal]: direction === 'horizontal'
      })}
      {...svgProps}
      preserveAspectRatio="none"
      {...restProps}
    >
      <line
        {...lineProps}
        strokeWidth={strokeWidth}
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeDasharray="8 8"
      />
    </svg>
  );
});
